const STRING = 'string';
const NUMBER = 'number';
const DATETIME = 'dateTime';
const DARK = 'dark';
const LIGHT = 'light';
const VEHICLE_STATUS = {
  Active: 'Active',
  Inactive: 'Inactive',
};
const TEST = 'test';
const TRIP_KEYS = {
  INPROGRESS: 'inprogress',
  NOSHOW: 'noshow',
  PICKUP: 'Pickup',
  DROP: 'Drop',
  COMPLETED: 'completed',
  ACTIVE: 'active',
};
const BROADCAST_STATUS_KEYS = {
  FAILED: 'failed',
  PENDING: 'pending',
  SUCCESS: 'played',
};

const DEVICE_STATUS = {
  ON: 'ON',
  OFF: 'OFF',
};

const HYPHEN = '-';
const SOS_STATUS = {
  RESOLVED: 'Resolved',
  IN_PROGRESS: 'In progress',
  PENDING: 'Pending',
  INPROGRESS: 'In progress',
};

const SOS_STATUS_KEYS = {
  RESOLVED: 'Closed',
  IN_PROGRESS: 'InProgress',
  PENDING: 'Open',
};
const SOS_STATUS_KEYS_TEXT = {
  RESOLVED: 'Resolved',
  IN_PROGRESS: 'In Progress',
  PENDING: 'New',
};

const ANOMALY_ALERTS = {
  OVER_SPEEDING: 'Over Speeding',
  RASH_DRIVING: 'Rash Driving',
  SOS: 'SOS',
  DRIVER_DROWSINESS: 'Driver Drowsiness',
  DRIVER_DISTRACTION: 'Driver Distraction',
  DOOR_OPEN: 'Door Open',
};

const ANOMALY_ALERTS_FILTER_KEYS = {
  OVER_SPEED: 'overspeed',
  RASH_DRIVING: 'rash_driving',
  SOS: 'sos',
  DOOR_OPEN: 'door_anomaly',
  DRIVER_DROWSINESS: 'dms_drowsy',
};

const API_RESPONSE_STATUS = {
  SUCCESS: 200,
};

const SORT = {
  ASCEND_BE: 'asc',
  DESCEND_BE: 'desc',
  ASCEND_ANTD: 'ascend',
  DESCEND_ANTD: 'descend',
};

const ANOMALY_TYPE = {
  CRITICAL: 'Critical',
  MAJOR: 'Major',
  MINOR: 'Minor',
  DRIVER_DROWSINESS: 'Driver Drowsiness',
  DRIVER_ANOMALIES: 'Driver Anomalies',
};

const CHART_BG_COLOR = 'rgba(0,0,0,0)';

const CHART_MARGINS = {
  l: 20,
  r: 20,
  b: 20,
  t: 20,
};

const DEVICE_MANAGEMENT_KEYS = {
  // DRIVERS: 'drivers',
  DEVICES: 'devices',
  ACTIVITY_LOGS: 'activity_logs',
  ONBOARDED_DEVICES: 'onboarded_devices',
};

const USER_MANAGEMENT_KEYS = {
  USERS: 'users',
  ROLES: 'roles',
  COMPANIES: 'companies',
  ACTIVITY_LOGS: 'activity_logs',
};

const FILE_ACCESS_STATUS = {
  PENDING_APPROVAL: 'inprogress',
  APPROVED: 'available',
  UNAVAILABLE: 'unavailable',
  CLOSED: 'closed',
};

const TRIP_TRACKING_KEYS = {
  PICKUP: 'pickup',
  DROP: 'drop',
};

const SOS_CALL_TYPES = {
  GENUINE_CALL: 'Genuine call',
  FALSE_ALERT: 'False Alert',
};

const SOS_TYPES = {
  MEDICAL_EMERGENCY: 'Medical emergency',
  ROAD_ACCIDENT: 'Road accident',
  FIGHT: 'Fight',
  OTHERS: 'Others',
};

const SOS_TRIGGER_TYPES = {
  MANUAL: 'manual',
  MANUAL_DASHBOARD: 'manual_dashboard',
};

const VIEW_TYPES = {
  GRID: 'grid',
  LIST: 'list',
};

const INDIA_BOUNDS = {
  north: 35.513327,
  south: 6.4626999,
  west: 68.1766451,
  east: 97.395561,
};

const DEFAULT_MAP_BOUNDS = {
  north: 13.2,
  south: 12.75,
  east: 77.9,
  west: 77.4,
};

const TRIP_CONSOLIDATED_STATUS = {
  OPEN: 'Open',
  CLOSED: 'Closed',
};

const INVALID_VIDEO_URLS = [
  'No video found',
  'inprogress',
  'closed',
  'available',
  'unavailable',
];

const VIDEO_STATUS_MESSAGES = {
  'No video found': 'No video to show at the moment',
  inprogress: 'Upload in progress',
  closed: 'Video no longer available',
  available: 'Video available',
  unavailable: 'Video unavailable',
};

const DMS_TYPE = {
  DROWSINESS: 'dms_drowsy',
  DISTRACTION: 'dms_distraction',
};

const ANOMALY_SVG_PATH = {
  DRIVER_DROWSINESS:
    '<path d="M26.2308 38H23.6155C23.1552 38 22.7708 37.8458 22.4625 37.5375C22.1542 37.2292 22 36.8448 22 36.3845V33.7693H23V36.3845C23 36.564 23.0577 36.7115 23.173 36.827C23.2885 36.9423 23.436 37 23.6155 37H26.2308V38ZM37.7693 38V37H40.3845C40.564 37 40.7115 36.9423 40.827 36.827C40.9423 36.7115 41 36.564 41 36.3845V33.7693H42V36.3845C42 36.8448 41.8458 37.2292 41.5375 37.5375C41.2292 37.8458 40.8448 38 40.3845 38H37.7693ZM32 33.7308C30.218 33.7308 28.617 33.2257 27.197 32.2155C25.7772 31.2052 24.7051 29.8 23.9807 28C24.7051 26.2 25.7772 24.7948 27.197 23.7845C28.617 22.7743 30.218 22.2693 32 22.2693C33.782 22.2693 35.383 22.7743 36.803 23.7845C38.2228 24.7948 39.2949 26.2 40.0193 28C39.2949 29.8 38.2228 31.2052 36.803 32.2155C35.383 33.2257 33.782 33.7308 32 33.7308ZM32 32.7308C33.518 32.7308 34.8789 32.3179 36.0828 31.4923C37.2866 30.6666 38.2327 29.5025 38.9212 28C38.2327 26.4975 37.2866 25.3334 36.0828 24.5078C34.8789 23.6821 33.518 23.2693 32 23.2693C30.482 23.2693 29.1211 23.6821 27.9173 24.5078C26.7134 25.3334 25.7673 26.4975 25.0787 28C25.7673 29.5025 26.7134 30.6666 27.9173 31.4923C29.1211 32.3179 30.482 32.7308 32 32.7308ZM32 30.8655C32.8 30.8655 33.4776 30.5879 34.0328 30.0328C34.5879 29.4776 34.8655 28.8 34.8655 28C34.8655 27.2 34.5879 26.5224 34.0328 25.9673C33.4776 25.4121 32.8 25.1345 32 25.1345C31.2 25.1345 30.5224 25.4121 29.9673 25.9673C29.4121 26.5224 29.1345 27.2 29.1345 28C29.1345 28.8 29.4121 29.4776 29.9673 30.0328C30.5224 30.5879 31.2 30.8655 32 30.8655ZM32 29.8655C31.4808 29.8655 31.0402 29.6843 30.678 29.322C30.3157 28.9598 30.1345 28.5192 30.1345 28C30.1345 27.4808 30.3157 27.0402 30.678 26.678C31.0402 26.3157 31.4808 26.1345 32 26.1345C32.5192 26.1345 32.9598 26.3157 33.322 26.678C33.6843 27.0402 33.8655 27.4808 33.8655 28C33.8655 28.5192 33.6843 28.9598 33.322 29.322C32.9598 29.6843 32.5192 29.8655 32 29.8655ZM22 22.2307V19.6155C22 19.1552 22.1542 18.7708 22.4625 18.4625C22.7708 18.1542 23.1552 18 23.6155 18H26.2308V19H23.6155C23.436 19 23.2885 19.0577 23.173 19.173C23.0577 19.2885 23 19.436 23 19.6155V22.2307H22ZM41 22.2307V19.6155C41 19.436 40.9423 19.2885 40.827 19.173C40.7115 19.0577 40.564 19 40.3845 19H37.7693V18H40.3845C40.8448 18 41.2292 18.1542 41.5375 18.4625C41.8458 18.7708 42 19.1552 42 19.6155V22.2307H41Z" fill="white"/>',
  OVER_SPEEDING:
    '<path d="M30.6197 31.3247C30.9643 31.6695 31.4066 31.8265 31.9466 31.7958C32.4864 31.7652 32.8803 31.5711 33.1283 31.2135L38.9657 23.0769L30.7863 28.8716C30.4145 29.1196 30.2075 29.5042 30.1655 30.0255C30.1235 30.547 30.2749 30.98 30.6197 31.3247ZM31.9999 20C33.0212 20 33.951 20.1243 34.7894 20.3728C35.6277 20.6215 36.4629 21.0015 37.2949 21.5128L36.2735 22.205C35.6196 21.8476 34.9426 21.5759 34.2424 21.39C33.5422 21.2041 32.7947 21.1111 31.9999 21.1111C29.537 21.1111 27.4398 21.9768 25.7083 23.7083C23.9768 25.4398 23.1111 27.537 23.1111 29.9999C23.1111 30.7777 23.2176 31.5462 23.4305 32.3055C23.6435 33.0647 23.9444 33.7777 24.3333 34.4444H39.6666C40.0925 33.7407 40.4027 33.0092 40.5971 32.2499C40.7915 31.4907 40.8888 30.7036 40.8888 29.8888C40.8888 29.2222 40.8029 28.5206 40.6313 27.7841C40.4596 27.0476 40.1879 26.3617 39.816 25.7264L40.5085 24.705C41.0498 25.6324 41.4326 26.505 41.6568 27.3227C41.8813 28.1403 41.9956 28.9914 41.9999 29.876C42.0041 30.8318 41.898 31.7235 41.6815 32.5513C41.4651 33.3789 41.1281 34.2136 40.6707 35.0555C40.5811 35.2036 40.4458 35.324 40.2649 35.4166C40.084 35.5092 39.8845 35.5555 39.6666 35.5555H24.3333C24.1296 35.5555 23.9409 35.5056 23.7672 35.406C23.5933 35.3062 23.4473 35.1608 23.3292 34.9699C22.9616 34.3218 22.6481 33.5907 22.3889 32.7766C22.1296 31.9625 22 31.037 22 29.9999C22 28.6338 22.2591 27.3446 22.7772 26.1322C23.2954 24.9196 24.0026 23.8576 24.8989 22.9461C25.7953 22.0348 26.8554 21.3159 28.0791 20.7894C29.3026 20.2631 30.6096 20 31.9999 20Z" fill="white"/>',
  DOOR_OPEN:
    '<path d="M35.9915 24.8311C32.8868 23.634 31.1391 23.6215 28.0085 24.8311L28.8955 29.3571C31.9877 28.1869 31.9636 28.1638 35.1045 29.3571L35.9915 24.8311ZM35.9915 24.8311C37.322 24.381 38.4456 24.9841 39.1848 25.2857M29.0966 34.8908C31.712 35.0182 32.5981 35.0243 35.3057 34.8908M23 29.677L26.2344 26.6429L26.2344 23.0238C26.2344 20.5254 28.2201 18.5 30.6695 18.5H33.3305C35.7799 18.5 37.7656 20.5254 37.7656 23.0238L37.7655 26.6429L41 29.677M28.0084 24.8333C27.2693 24.5317 25.9683 24.5619 24.9039 25.2857M37.7656 31.1667V34.7857C37.7656 36.2848 36.5742 37.5 35.1045 37.5H28.8955C27.4258 37.5 26.2344 36.2848 26.2344 34.7857L26.2344 31.1667" stroke="white"/>',
  SOS: '<path d="M31.375 39V34H32.625V39H31.375ZM40.8438 35.315L37.2956 31.7981L38.1875 30.9062L41.7044 34.4544L40.8438 35.315ZM23.1562 35.315L22.2956 34.4544L25.8125 30.9062L26.7044 31.7981L23.1562 35.315ZM23.25 20.25V21.6922C23.25 21.9166 23.3221 22.1009 23.4662 22.2453C23.6106 22.3895 23.795 22.4616 24.0194 22.4616H39.9806C40.205 22.4616 40.3894 22.3895 40.5338 22.2453C40.6779 22.1009 40.75 21.9166 40.75 21.6922V20.25H23.25ZM26.4038 23.7116L27.0194 25.4181C27.0833 25.5785 27.1795 25.7028 27.3078 25.7909C27.4359 25.8791 27.5801 25.9231 27.7403 25.9231H36.2597C36.4199 25.9231 36.5641 25.8791 36.6922 25.7909C36.8205 25.7028 36.9167 25.5785 36.9806 25.4181L37.5963 23.7116H26.4038ZM27.7403 27.1731C27.3109 27.1731 26.9216 27.0517 26.5722 26.8088C26.2228 26.566 25.9728 26.2404 25.8222 25.8319L25.0769 23.7116H24.0194C23.46 23.7116 22.9835 23.5148 22.59 23.1213C22.1967 22.7279 22 22.2516 22 21.6922V19H42V21.6922C42 22.2516 41.8033 22.7279 41.41 23.1213C41.0165 23.5148 40.54 23.7116 39.9806 23.7116H38.9231L38.0866 25.8606C37.9311 26.2435 37.6851 26.558 37.3484 26.8041C37.012 27.0501 36.6315 27.1731 36.2069 27.1731H27.7403Z" fill="white"/>',
  RASH_DRIVING:
    '<path d="M22 29.2819L24.205 23C24.2593 22.8233 24.3636 22.6866 24.5181 22.5897C24.6727 22.4929 24.8447 22.4444 25.0342 22.4444H30.0533C30.0406 22.6296 30.0413 22.8148 30.0556 23C30.0698 23.1852 30.0905 23.3704 30.1175 23.5556H25.2094L23.5728 28.1708H33.2031C33.646 28.4729 34.1154 28.7176 34.6111 28.905C35.1069 29.0922 35.6381 29.2179 36.205 29.2819H23.1111V34.6667H38.6667V29.5192C38.8419 29.5064 39.0292 29.4694 39.2286 29.4081C39.4281 29.3468 39.6111 29.2684 39.7778 29.1731V37.4444C39.7778 37.6019 39.7245 37.7338 39.6181 37.8403C39.5116 37.9468 39.3796 38 39.2222 38H38.9658C38.8084 38 38.6765 37.9468 38.57 37.8403C38.4635 37.7338 38.4103 37.6019 38.4103 37.4444V35.7778H23.3675V37.4444C23.3675 37.6019 23.3143 37.7338 23.2078 37.8403C23.1013 37.9468 22.9694 38 22.8119 38H22.5556C22.3981 38 22.2662 37.9468 22.1597 37.8403C22.0532 37.7338 22 37.6019 22 37.4444V29.2819ZM35.9794 33.2136C36.325 33.2136 36.6171 33.0927 36.8558 32.8508C37.0944 32.6088 37.2136 32.315 37.2136 31.9694C37.2136 31.6237 37.0927 31.3316 36.8508 31.0931C36.6088 30.8544 36.315 30.735 35.9694 30.735C35.6237 30.735 35.3316 30.856 35.0931 31.0981C34.8544 31.3399 34.735 31.6337 34.735 31.9794C34.735 32.325 34.856 32.6171 35.0981 32.8558C35.3399 33.0944 35.6337 33.2136 35.9794 33.2136ZM25.8083 33.2136C26.1541 33.2136 26.4462 33.0927 26.6847 32.8508C26.9234 32.6088 27.0428 32.315 27.0428 31.9694C27.0428 31.6237 26.9218 31.3316 26.6797 31.0931C26.4379 30.8544 26.1441 30.735 25.7983 30.735C25.4528 30.735 25.1606 30.856 24.9219 31.0981C24.6834 31.3399 24.5642 31.6337 24.5642 31.9794C24.5642 32.325 24.6851 32.6171 24.9269 32.8558C25.169 33.0944 25.4628 33.2136 25.8083 33.2136ZM37.1194 26.8889C35.8874 26.8889 34.8401 26.4576 33.9775 25.595C33.1151 24.7326 32.6839 23.6797 32.6839 22.4364C32.6839 21.2081 33.1144 20.1616 33.9753 19.2969C34.8362 18.4323 35.8901 18 37.1369 18C38.369 18 39.4163 18.4313 40.2789 19.2939C41.1415 20.1563 41.5728 21.2065 41.5728 22.4444C41.5728 23.6824 41.1385 24.7326 40.27 25.595C39.4017 26.4576 38.3515 26.8889 37.1194 26.8889ZM36.7008 23.1283H37.5556V19.795H36.7008V23.1283ZM37.1283 25.1794C37.2765 25.1794 37.3954 25.131 37.485 25.0342C37.5748 24.9373 37.6269 24.8219 37.6411 24.6881C37.6411 24.5456 37.5927 24.421 37.4958 24.3142C37.399 24.2073 37.2765 24.1539 37.1283 24.1539C36.9802 24.1539 36.8576 24.2023 36.7606 24.2992C36.6637 24.396 36.6153 24.5185 36.6153 24.6667C36.6153 24.8148 36.6637 24.9373 36.7606 25.0342C36.8576 25.131 36.9802 25.1794 37.1283 25.1794Z" fill="white"/>',
};

const ANOMALY_BG_COLOR = {
  MAJOR: '#AD8C00',
  MINOR: '#2E908B',
  SOS: '#ED0007',
  CRITICAL: '#FF2124',
  SOS_HOVER: '#BE0004',
  CRITICAL_HOVER: '#BE0004',
  MAJOR_HOVER: '#AD8C00',
  MINOR_HOVER: '#2E908B',
};
const SOS_TICKET_STATUS_BG_COLOR = {
  NEW: '#ED0007',
  INPROGRESS: '#007BC0',
  RESOLVED: '#00884A',
  NEW_HOVER: '#BE0004',
  INPROGRESS_HOVER: '#00629A',
  RESOLVED_HOVER: '#006C3A',
};

const DROWSINESS_MODEL_OUTPUT = {
  DROWSINESS: 'dms_drowsy',
  DISTRACTION: 'dms_distraction',
};

const USERS_ACCOUNT_STATUS_KEYS = {
  ALL: 'all',
  INVITE_SENT: 'email_sent',
  INVITE_EXPIRED: 'invite_expired',
  ACTIVE: 'active',
  DELETED: 'deleted',
  SOFT_DELETED: 'soft_deleted',
};

const DMS_ERROR_KEYS = {
  dms_camera_covered: 'Camera covered',
  dms_camera_not_connected: 'Camera error',
  dms_face_not_in_frame: 'Face not in frame',
};

const DEVICE_STATUS_KEYS = {
  NEW: 'new',
  ONBOARDED: 'onboarded',
  INSTALLED: 'commissioned',
  REPLACED: 'replaced',
  UNINSTALLED: 'decommissioned',
};

const USER_ROLE_KEYS = {
  SUPER_ADMIN: 'super_admin',
  COMPANY_ADMIN: 'admin',
  PLATFORM_OPERATION_MANAGER: 'platform_operation_manager',
  TRANSPORT_MANAGER: 'transport_manager',
  OPERATIONS: 'operations',
};

const PAGE_KEYS = {
  OVERVIEW: 'overview',
  VEHICLE_MONITORING: 'vehicle_monitoring',
  DRIVER_MONITORING_SYSTEM: 'driver_monitoring_system',
  BROADCAST: 'broadcast',
  DEVICE_MANAGEMENT: 'device_management',
  SAFETY_AND_ANOMALY_MONITORING: 'safety_and_anomaly_monitoring',
  USER_MANAGEMENT: 'user_management',
  EXECUTIVE_CONSOLE: 'executive_console',
  HISTORY_AND_REPORTS: 'history_and_reports',
  TRIP_SURVEILLANCE_AND_ANALYSIS: 'trip_surveillance_and_analysis',
  TRIP_SCHEDULING_AND_MANAGEMENT: 'trip_scheduling_and_management',
};

const TRIP_VIDEO_STATUS = {
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  INPROGRESS: 'inprogress',
  ERROR: 'error',
};

const ORGANISATION_KEYS = {
  JPMC: 'jpmc',
};

const RESTRICT_DATA_DATE = {
  JPMC: '11-12-2025',
};

const DMS_ERROR_TICKET_STATUS = {
  PENDING: 'Pending',
  RESOLVED: 'Resolved',
};

const LOGIN_TYPE_KEYS = {
  SSO: 'sso',
  USER_PASSWORD: 'u_p',
  MFA: 'mfa',
};

const LOGIN_TYPE_MESSAGES = {
  [LOGIN_TYPE_KEYS.SSO]:
    "Please authenticate via your organization's single sign-on to proceed",
  [LOGIN_TYPE_KEYS.USER_PASSWORD]: 'Please enter your password to proceed',
  [LOGIN_TYPE_KEYS.MFA]: 'Please enter your password to proceed',
};

const INITIAL_TRIP_START_END_PAYLOAD = {
  clientId: 'rbtesting-blr',
  tripEndTime: '2026-03-02T12:00:00Z',
  tripStartTime: '2026-03-02T12:00:00Z',
  tripId: 'dec3test3',
  eventType: 'trip-status',
  tripStatus: 'STARTED',
};

const INITIAL_TRIP_SCHEDULE_PAYLOAD = {
  clientId: 'rbtesting-blr',
  tripEndTime: '2026-03-02T12:00:00Z',
  tripStartTime: '2026-03-02T12:00:00Z',
  tripId: 'jan19test1902',
  eventType: 'trip-status',
  tripStatus: 'STARTED',
  tripPayload: {
    clientId: 'rbtesting-blr',
    driverID: 'DR202212-1416-5613-062J-1T7YTHWP57GI',
    tripId: 'jan19test1902',
    eventType: 'trip-data',
    dutyEndTime: '2026-01-16T23:10:00Z',
    dutyStartTime: '2026-01-16T10:00:00Z',
    requestType: 'REGULAR',
    tripEndTime: '2026-01-16T23:10:00Z',
    tripStartTime: '2026-01-16T10:00:00Z',
    cabDTO: {
      guId: 'VEHjpmcB-lr$0-0000-0000-000000009985',
      cabId: '251',
      contractId: 'None',
      registration: 'KA01QAD100',
      vendor: 'None',
      cabType: 'None',
      device: {
        deviceId: 0,
        guid: 'None',
        deviceUUID: 'a8f74b66-ba9f-44ef-93d4-c7532a507140',
        imei: '355729335460197',
        simNumber: 'None',
        status: 'None',
        network: 'None',
        phoneNumber: '',
      },
      driver: {
        guid: 'DR202212-1416-5613-062J-1T7YTHWP57GI',
        name: 'ANIS I M',
        phoneNumbers: ['9999999999'],
        driverPhotoPath: 'None',
        device: 'None',
      },
      status: 'None',
      externalDeviceIMEI: 'None',
      virtual: false,
    },
    employees: [],
  },
};

const DMS_ACTION_OPTIONS = {
  FALSE_ALARM: 'False alarm',
  WARNING_GIVEN: 'Warning given',
  VEHICLE_REPLACED: 'Vehicle replaced',
  OTHER_REASON: 'Other reason',
};

const colResponsiveProps = {
  xs: { span: 24 },
  sm: { span: 24 },
  md: { span: 24 },
  lg: { span: 24 },
  xl: { span: 12 },
  xxl: { span: 12 },
  xxxl: { span: 12 },
};

const rowResponsiveProps = {
  gutter: {
    xs: 0,
    sm: 0,
    md: 0,
    lg: 0,
    xl: 40,
    xxl: 40,
    xxxl: 40,
  },
};

const anomalyDownloadFormatOptions = {
  formatHeaders: true,
  enableFormatting: true,
  selectedColumns: [
    'trip_id',
    'sticker_id',
    'device_id',
    'vehicle_number',
    'anomaly_type',
    'severity',
    'timestamp',
    'driver_name',
    'total_passengers',
  ],
  headerOptions: {
    customMappings: {
      trip_id: 'Trip ID',
      sticker_id: 'Sticker ID',
      device_id: 'Device ID',
      vehicle_number: 'Vehicle Number',
      anomaly_type: 'Anomaly Type',
      severity: 'Severity',
      timestamp: 'Timestamp',
      driver_name: 'Driver Name',
      total_passengers: 'Total Passengers',
    },
  },
};

const sosDownloadFormatOptions = {
  formatHeaders: true,
  enableFormatting: true,
  selectedColumns: [
    'trip_id',
    'device_id',
    'cab_registration',
    'timestamp',
    'call_type',
    'sos_type',
    'reporter',
    'assigned_to',
    'ticket_status',
    'so_ticket_id',
    'drivername',
    'description',
    'comments',
    'resolved_by',
  ],
  headerOptions: {
    customMappings: {
      trip_id: 'Trip ID',
      device_id: 'Device ID',
      cab_registration: 'Vehicle Number',
      timestamp: 'Timestamp',
      call_type: 'Call Type',
      sos_type: 'SOS Type',
      reporter: 'Reporter',
      assigned_to: 'Assigned To',
      ticket_status: 'Ticket Status',
      so_ticket_id: 'SO Ticket ID',
      drivername: 'Driver Name',
      description: 'Description',
      comments: 'Comments',
      resolved_by: 'Resolved By',
    },
  },
  valueMappings: {
    ticket_status: {
      InProgress: 'In Progress',
      Closed: 'Resolved',
      Open: 'New',
      __default__: '',
    },
  },
};

const dmsDownloadFormatOptions = {
  formatHeaders: true,
  enableFormatting: true,
  selectedColumns: [
    'trip_id',
    'sticker_id',
    'device_id',
    'vehicle_number',
    'driver_name',
    'revised_anomaly_type',
    'timestamp',
    'ticket_status',
    'action_taken',
    'comment',
    'action_taken_by',
    'action_timestamp',
  ],
  headerOptions: {
    customMappings: {
      trip_id: 'Trip ID',
      sticker_id: 'Sticker ID',
      device_id: 'Device ID',
      vehicle_number: 'Vehicle Number',
      driver_name: 'Driver Name',
      revised_anomaly_type: 'Event Status',
      timestamp: 'Timestamp',
      ticket_status: 'Ticket Status',
      action_taken: 'Action Taken',
      comment: 'Comment',
      action_taken_by: 'Action Taken By',
      action_timestamp: 'Action Timestamp',
    },
  },
  valueMappings: {
    revised_anomaly_type: {
      'Driver drowsy': 'Drowsy',
      'Driver distracted': 'Drowsy not detected',
      __default__: '',
    },
  },
};

const cameraErrorDownloadFormatOptions = {
  formatHeaders: true,
  enableFormatting: true,
  selectedColumns: [
    'trip_id',
    'sticker_id',
    'device_id',
    'vehicle_number',
    'drivername',
    'anomaly_type',
    'location',
    'ticket_status',
    'resolved_by',
    'event_timestamp',
    'created_timestamp',
  ],
  headerOptions: {
    customMappings: {
      trip_id: 'Trip ID',
      sticker_id: 'Sticker ID',
      device_id: 'Device ID',
      vehicle_number: 'Vehicle Number',
      drivername: 'Driver Name',
      anomaly_type: 'Error Type',
      location: 'Location',
      ticket_status: 'Status',
      resolved_by: 'Resolved By',
      event_timestamp: 'Timestamp',
      created_timestamp: 'Created Timestamp',
    },
  },
  valueMappings: {
    anomaly_type: {
      ...DMS_ERROR_KEYS,
      __default__: '',
    },
  },
  mergeColumns: [
    {
      key: 'location',
      from: ['latitude', 'longitude'],
      compute: (lat, lng) => (lat && lng ? `${lat}, ${lng}` : ''),
    },
  ],
};

const broadcastDownloadFormatOptions = {
  formatHeaders: true,
  enableFormatting: true,
  selectedColumns: [
    'broadcast_id',
    'trip_id',
    'registration',
    'device_id',
    'created_timestamp',
    'text_message',
    'trigger_frequency',
    'broadcast_status',
    'sent_by',
  ],
  headerOptions: {
    customMappings: {
      broadcast_id: 'Broadcast ID',
      trip_id: 'Trip ID',
      registration: 'Vehicle Number',
      device_id: 'Device ID',
      created_timestamp: 'Timestamp',
      text_message: 'Message',
      trigger_frequency: 'Frequency',
      broadcast_status: 'Sent Status',
      sent_by: 'Sent By',
    },
  },
  valueMappings: {
    broadcast_status: {
      pending: 'Pending',
      played: 'Success',
      __default__: '',
    },
  },
};

export {
  STRING,
  NUMBER,
  DATETIME,
  DARK,
  LIGHT,
  VEHICLE_STATUS,
  TEST,
  TRIP_KEYS,
  BROADCAST_STATUS_KEYS,
  DEVICE_STATUS,
  HYPHEN,
  SOS_STATUS,
  SOS_STATUS_KEYS,
  SOS_STATUS_KEYS_TEXT,
  ANOMALY_ALERTS,
  API_RESPONSE_STATUS,
  SORT,
  ANOMALY_TYPE,
  CHART_BG_COLOR,
  CHART_MARGINS,
  DEVICE_MANAGEMENT_KEYS,
  USER_MANAGEMENT_KEYS,
  FILE_ACCESS_STATUS,
  TRIP_TRACKING_KEYS,
  INDIA_BOUNDS,
  DEFAULT_MAP_BOUNDS,
  SOS_CALL_TYPES,
  VIEW_TYPES,
  TRIP_CONSOLIDATED_STATUS,
  INVALID_VIDEO_URLS,
  VIDEO_STATUS_MESSAGES,
  DMS_TYPE,
  ANOMALY_SVG_PATH,
  ANOMALY_BG_COLOR,
  SOS_TICKET_STATUS_BG_COLOR,
  DROWSINESS_MODEL_OUTPUT,
  USERS_ACCOUNT_STATUS_KEYS,
  DMS_ERROR_KEYS,
  DEVICE_STATUS_KEYS,
  USER_ROLE_KEYS,
  PAGE_KEYS,
  LOGIN_TYPE_KEYS,
  LOGIN_TYPE_MESSAGES,
  TRIP_VIDEO_STATUS,
  ORGANISATION_KEYS,
  RESTRICT_DATA_DATE,
  INITIAL_TRIP_START_END_PAYLOAD,
  INITIAL_TRIP_SCHEDULE_PAYLOAD,
  DMS_ERROR_TICKET_STATUS,
  SOS_TYPES,
  DMS_ACTION_OPTIONS,
  colResponsiveProps,
  rowResponsiveProps,
  SOS_TRIGGER_TYPES,
  ANOMALY_ALERTS_FILTER_KEYS,
  anomalyDownloadFormatOptions,
  sosDownloadFormatOptions,
  dmsDownloadFormatOptions,
  cameraErrorDownloadFormatOptions,
  broadcastDownloadFormatOptions,
};
